import { useLayoutEffect } from "react";

import { Outlet, useLocation } from "react-router-dom";

import MainNavigation from "./header/MainNavigation";
import MainFooter from "./footer/MainFooter";

export default function RootLayout() {
  const location = useLocation();

  useLayoutEffect(() => {
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <>
      <MainNavigation />
      <div>
        <Outlet />
      </div>
      <MainFooter />
    </>
  );
}
